import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import OptionGroupSingle from './OptionGroupSingle';

export class OptionGroups extends PureComponent {
  render() {
    const {optionGroups, updateOptionGroups, selectedOptions, basketModalMode, selectedSizeChanged} = this.props;
    const renderOptionGroups = optionGroups.map(optionGroup =>
      <OptionGroupSingle
        key={optionGroup.name}
        optionGroup={optionGroup}
        updateOptionGroups={updateOptionGroups}
        selectedOptions={selectedOptions}
        basketModalMode={basketModalMode}
        selectedSizeChanged={selectedSizeChanged}
      />
    );

    return (
      <div>
        {renderOptionGroups}
      </div>
    );
  }
}

OptionGroups.propTypes = {
  optionGroups: PropTypes.array.isRequired,
  updateOptionGroups: PropTypes.func.isRequired,
  selectedOptions: PropTypes.array,
  basketModalMode: PropTypes.string,
  selectedSizeChanged: PropTypes.bool.isRequired
};

export default OptionGroups;



// WEBPACK FOOTER //
// ./components/Meal/OptionGroups.js